import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { SignalStrengthIndicator } from './Media';


function Footer(props) {

  return (
     <footer className="footer">
      <div className="float-right ml-1 mr-2">
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-connected`}>
             {props.connected ? "Conectado": "Desconectado"}
            </Tooltip>
          }
        >
        <FontAwesomeIcon icon="circle" className={props.connected ? "text-success": "text-muted"} />
        </OverlayTrigger>
      </div>
      <div className="float-right ml-2 mr-1">
        { props.mediaType === "webrtc" &&
          <SignalStrengthIndicator strength={props.mediaSignalStrength}/>
        }
      </div>
    </footer>
  )
}

export default Footer;

